export default "__VITE_ASSET__CD4f4M9i__"